module.exports = __webpack_public_path__ + "img/GeheimesTreffen.cb6ef0e2.jpg";